import { render } from "./brandNews.vue?vue&type=template&id=3f8ce9d9&scoped=true"
import script from "./brandNews.vue?vue&type=script&lang=js"
export * from "./brandNews.vue?vue&type=script&lang=js"

import "./brandNews.vue?vue&type=style&index=0&id=3f8ce9d9&lang=scss&scoped=true"
import "./brandNews.vue?vue&type=style&index=1&id=3f8ce9d9&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8ce9d9"]])

export default __exports__